import { Metric } from '@trace/types';
import MathMax from 'lodash.max';
import MathMin from 'lodash.min';

const numberOrNull = (n: number | undefined | null) => (n === undefined ? null : n);

export type MinMaxDomain = [number, number];

export interface MinMaxPoint {
  avg: null | number;
  max: null | number;
  min: null | number;
  title: string;
}

export default function getMinMaxSeries(
  attributeValues: string[],
  metrics: Record<string, Metric<'percentile'>>,
): [MinMaxPoint[], MinMaxDomain] {
  let xLower: undefined | number;
  let xUpper: undefined | number;

  const series = attributeValues
    .map((title) => {
      if (!metrics[title]) {
        return { min: null, avg: null, max: null, title };
      }

      const min = numberOrNull(MathMin(metrics[title].views.percentile.p5));
      const avg = numberOrNull(MathMax(metrics[title].views.percentile.p50));
      const max = numberOrNull(MathMax(metrics[title].views.percentile.p95));

      if (min !== null && (xLower === undefined || min < xLower)) xLower = min;
      if (max !== null && (xUpper === undefined || max > xUpper)) xUpper = max;

      return { min, avg, max, title };
    })
    .sort((a, b) => {
      if (a.avg === null) return 1;
      if (b.avg === null) return -1;
      return b.avg - a.avg;
    });

  if (xLower === undefined) xLower = 0;
  if (xUpper === undefined || xLower === xUpper) xUpper = xLower + 1;

  return [series, [xLower, xUpper]];
}
